import { IAgentStatCode, ISelectedStatCodeData } from './StatModels';
export async function SetUserSelectedStatCode(selectedSubStat: string): Promise<ISelectedStatCodeData | null> {
  try {
    const res = await fetch(`/api/sitecore/Agency/SetAgentSelectedStatCode`, {
      method: 'POST',
      body: new URLSearchParams({ subStatCode: selectedSubStat }),
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: ISelectedStatCodeData = await res.json();
        return data;
      }
    }
  } catch {
    console.error('Error saving stat code for user');
    return null;
  }
  return null;
}
export async function GetAgentStatCodes(): Promise<IAgentStatCode[]> {
  try {
    const res = await fetch(`/api/sitecore/NowNavigationAsync/GetAgentStatCodes`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: IAgentStatCode[] = await res.json();
        return data;
      }
    }
  } catch {
    console.error('Error saving state for user');
    return [];
  }
  return [];
}
